import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";

export default function BodyInfoListItem(props) {
  const head = props.head;
  const text = props.text;
  return (
    <Box
      sx={{
        display: "flex",
        borderBottom: 1,
        borderColor: "#eee",
        p: "20px",
      }}
    >
      <Grid container>
        <Grid item xs={4} sm={3}>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "bold",
              width: { xs: "120px", sm: "180px" },
            }}
          >
            {head}
          </Typography>
        </Grid>
        <Grid item xs={8} sm={9}>
          <Typography sx={{ fontSize: "14px" }}>{text}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
